import React from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import './hero.css'

export default function Hero() {

  AOS.init()

  return ( 
    <div id='hero' className='container-fluid bg-danger g-0'>
      <div className='container h-100 g-0'>
        <div className='row mt-5 bg-light p-5 shadow-lg'>
            <div className='col-lg-6 my-auto pb-3' data-aos="fade-up"
                 data-aos-delay="500" >
                <h1 className='display-1 text-danger fw-bold'> Mariscos La Paz </h1>
                <a href='tel:3921060763' className='btn btn-outline-danger btn-lg mt-2 mb-3'>Tel: 392 10 60 763 </a>
              <p className='lead text-danger'>
                Juárez 47, Colonia Centro
                </p>
                <p className='lead text-danger'>Jamay, Jalisco</p>
            </div>
            <div className='col-lg-6 pb-3 my-auto' 
                 data-aos="fade-up"
                 data-aos-delay="800">
              <p className='lead text-danger fw-bold'>Servicio a Domicilio</p>
              <a href='tel:392 100 9557'>
                <img className='img-thumbnail shadow-lg'  src={require('./Assets/mandaditos.jpg')} alt='mandaditos' />
              </a>
            </div>
            <p className='lead text-danger mt-3'>Siguenos: <a href='https://es-es.facebook.com/people/Mariscos-loncheria-y-micheladas-la-paz/100054320689941/'><i className="bi bi-facebook text-danger lead"></i></a></p>
          </div>    
      </div>

    </div>
  )
}
